import axios from "axios";

export const REACT_APP_CLIENT_ID = "62095";
export const REACT_APP_CLIENT_SECRET = "13f75c633dafe058aba6ec6731563947d8eebfdb";

export const getParamValues = (url) => {
    return url
        .slice(1)
        .split("&")
        .reduce((prev, curr) => {
            const [title, value] = curr.split("=");
            prev[title] = value;
            return prev;
        }, {});
};

export const cleanUpAuthToken = (str) => {
    return str.split("&")[1].slice(5);
};

export const testAuthGetter = async (authTok) => {
    try {
        const response = await axios.post(
            `https://www.strava.com/api/v3/oauth/token?client_id=${REACT_APP_CLIENT_ID}&client_secret=${REACT_APP_CLIENT_SECRET}&code=${authTok}&grant_type=authorization_code`
        );
        return response.data;
    } catch (error) {
        console.log(error);
        return null;
    }
};

export const getUserData = async (userID, accessToken) => {
    try {
        const response = await axios.get(
            `https://www.strava.com/api/v3/athletes/${userID}/stats`,
            { headers: { Authorization: `Bearer ${accessToken}` } }
        );
        return response.data || null;
    } catch (error) {
        console.log(error);
        return null;
    }
};

export const getUserActivities = async (accessToken) => {
    try {
        const response = await axios.get(
            `https://www.strava.com/api/v3/athlete/activities`,
            { headers: { Authorization: `Bearer ${accessToken}` } }
        );
        return response.data || null;
    } catch (error) {
        console.log(error);
        return null;
    }
};

export const saveOrderData = async (orderData) => {
    try {
        const response = await fetch('https://trailmaps.app.hoome.co.uk/api/firebase/database/createOrders', { 
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(orderData),
        });
        return await response.json();
    } catch (error) {
        console.error('Error saving order:', error);
        throw error;
    }
};

export const loadOrderData = async (orderId) => {
    try {
        const response = await fetch(`https://trailmaps.app.hoome.co.uk/api/firebase/database/getOrder?orderId=${orderId}`);
        if (!response.ok) {
            throw new Error('Order not found');
        }
        const data = await response.json();
        return data.order; // The API returns { order: {...} }
    } catch (error) {
        console.error('Error loading order:', error);
        throw error;
    }
};

export const generateOrderId = () => {
    return Math.random().toString(36).substring(2, 10).toUpperCase();
};
